<template>
  <span class="apphome">
    <div class="apphome_box">

      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="实时值" name="rtValue">
          <span style="margin-bottom:12px;display:flex;">
            <el-button type="primary" @click="handleExportRtvalueExcel">导出</el-button>
            <el-popover style="margin-left:10px" placement="top" width="360" v-model="visible">
              <el-upload class="upload-demo" drag action="http://127.0.0.1:19000/manualInputVariable/rtValueImport"
                multiple :on-success="handleUploadSuccess">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
              </el-upload>
              <el-button slot="reference" type="primary">导入</el-button>
            </el-popover>
            <el-button style="margin-left:10px" type="primary" @click="handleUpdateRtvalue">更新到实时库</el-button>
            <el-button style="margin-left:10px" type="primary" @click="getList">刷新</el-button>
            <el-input style="width:200px;margin-left: auto;" placeholder="请输入变量名称" v-model="queryInput" clearable>
            </el-input>
          </span>

          <el-table id="demo" v-loading="loading"
            :header-cell-style="{ color: '#333', fontFamily: 'MicrosoftYaHeiUI', fontSize: '14px', fontWeight: 900, backgroundColor: '#f5f7fa' }"
            stripe :data="tableData" border style="width: 100%" row-key="Id" @selection-change="handleSelectionChange">
            <template slot="empty">
              <span class="noData">
                <img src="../../assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column type="selection" width="50" align="center" fixed />
            <el-table-column v-for="(item, index) in columns" :key='index' :label="item.name" :align="item.al"
              :Width="item.width">
              <template slot-scope="scope">
                <input ref="input" v-if="flag == (item.key + scope.$index)" v-model.lazy="scope.row[item.key]"
                  @blur="flag = ''" autofocus class="el-input__inner" type="number"
                  style="height: 28px;line-height: 28px;">
                <span v-else @click="row_fn(item.key, scope.$index)">{{ scope.row[item.key] }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="currentSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 15px;">
          </el-pagination>
        </el-tab-pane>
        <el-tab-pane label="历史值" name="history">
          <temp v-if="activeName == 'history'"></temp>
        </el-tab-pane>
      </el-tabs>
    </div>
  </span>
</template>
<script>

  import temp from "@/page/manualInputVariable/temp";

  export default {
    components: {
      temp
    },
    data () {

      return {
        activeName: 'rtValue',
        queryInput: '',
        loading: false,
        total: 0,
        currentPage: 1,
        currentSize: 10,
        flag: '',//需要显示的key+索引 日
        visible: false,
        list: '',
        temp: {},
        tableData: [],
        dialogVisible: false,
        columns: [{
          name: "变量名称",
          key: "variableName",
          width: 150,
          al: 'left'
        },{
          name: "原值",
          key: "oldValue",
          width: 120,
          al: 'center'
        },{
          name: "新值",
          key: "newValue",
          width: 120,
          al: 'center'
        }],
        multipleSelection: []
      };
    },

    watch: {
      queryInput () {
        this.currentPage=1
        this.debounce(this.getList(),200)
      }
    },

    mounted () {
      this.getList();//获取列表数据  

    },
    methods: {
      debounce (func,wait,immediate) {
        let timeout,args,context,timestamp,result

        const later=function() {
          // 据上一次触发时间间隔
          const last=+new Date()-timestamp

          // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
          if(last<wait&&last>0) {
            timeout=setTimeout(later,wait-last)
          } else {
            timeout=null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if(!immediate) {
              result=func.apply(context,args)
              if(!timeout) context=args=null
            }
          }
        }

        return function(...args) {
          context=this
          timestamp=+new Date()
          const callNow=immediate&&!timeout
          // 如果延时不存在，重新设定延时
          if(!timeout) timeout=setTimeout(later,wait)
          if(callNow) {
            result=func.apply(context,args)
            context=args=null
          }

          return result
        }
      },

      handleSizeChange (s) {
        this.currentSize=s
        this.currentPage=1
        this.getList()
      },

      handleCurrentChange (p) {
        this.currentPage=p
        this.getList()
      },

      handleSelectionChange (v) {
        this.multipleSelection=v
      },

      row_fn (key,i) {
        if(!key.indexOf('variableName')!=-1) {
          this.flag=key+i;
        }
      },

      //获取列表数据
      async getList () {
        this.loading=true
        await this.$api.manualInputVariableApi.getRtValueList(this.currentPage,this.currentSize,this.queryInput,res => {
          if(res.data) {
            this.tableData=res.data
            this.total=res.total
            this.loading=false
          }
        })
      },

      handleExportRtvalueExcel () {
        if(isempty(this.multipleSelection)) {
          this.$message.warning("请选择有效数据")
          return
        }
        var list=this.multipleSelection
        this.$api.manualInputVariableApi.rtValueExport(list,res => {
          saveAs(`${DWSystemSetting.downloadUrl}${res}`,'人工填报实时值.xls')
        })
      },

      handleUploadSuccess (response,file,fileList) {
        // console.log(response, file, fileList)
        if(response.success) {
          let list=response.data
          list.forEach(element => {
            let currentIdIndex=this.tableData.findIndex(item => item.variableName===element.variableName)
            if(currentIdIndex!=-1) {
              this.tableData.splice(currentIdIndex,1,element)
            } else {
              this.tableData.push(element)
            }
          })
        }
      },

      handleUpdateRtvalue () {
        if(isempty(this.multipleSelection)) {
          this.$message.warning("请选择有效数据")
          return
        }
        var list=this.multipleSelection
        this.$api.manualInputVariableApi.rtValueUpdate(list,res => {
          console.log(res)
        })
      }

    }
  };
</script>

<style lang="scss" scoped>
  .box {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 10px;
  }

  .radio_box {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    padding: 5px 3px;

    .el-radio {
      margin-right: 3px;
    }
  }

  .avatar {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .wrapper {
    width: 100%;
    height: 500px;
  }

  .pagination_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
</style>